(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["customImageText"] && !Shopify.designMode) return;
  try {
    
$( document ).ready(function() {

$(document).ready(function() {
  $(".tablinks").click(function (e) {
  $(".tablinks").removeClass("active");
  $(e.target).addClass("active");
  });
  $("#defaultOpen").click();       
});

$(".tabcontent").hide();
$(".Standard").show();

$(".tablinks").click(function(){
  type = "."+$(this).attr("data-type");
  $(".tabcontent").hide();
  $(type).show();
})
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom_reviews"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".custom_review_item").forEach(review => {
    const textElement = review.querySelector(".custom_review_text");

    if (textElement) {
      const fullText = textElement.innerText.trim();

      if (fullText.length > 200) {
        const shortText = fullText.substring(0, 200) + "... ";
        textElement.dataset.fullText = fullText;
        textElement.innerHTML = shortText + `<span class="read-more-btn" style="color: black; font-weight: bold; cursor: pointer;">Read More</span>`;

        const button = textElement.querySelector(".read-more-btn");
        button.addEventListener("click", function () {
          if (textElement.classList.contains("expanded")) {
            textElement.innerHTML = shortText + `<span class="read-more-btn" style="color: black; font-weight: bold; cursor: pointer;">Read More</span>`;
            textElement.classList.remove("expanded");
          } else {
            textElement.innerHTML = fullText + ` <span class="read-more-btn" style="color: black; font-weight: bold; cursor: pointer;">Read Less</span>`;
            textElement.classList.add("expanded");
          }

          // Rebind event listener since we replaced the HTML
          textElement.querySelector(".read-more-btn").addEventListener("click", arguments.callee);
        });
      }
    }
  });
});

  } catch(e) { console.error(e); }
})();
})();
